import { disposeStrashAfterStormDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getdisposeStrashAfterStormEn = () => {
  const data = disposeStrashAfterStormDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const adddisposeStrashAfterStorm = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-dispose-of-trash-and-waste-after-a-hurricane-or-storm`,
    ) &&
    document.getElementById(`disposeStrashAfterStormJSONLD`) === null
  ) {
    const script = DisposeStrashAfterStormJSONLDEn()
    addJSONLDToHead(script, `disposeStrashAfterStormJSONLD`)
  } else {
    removeElement(`disposeStrashAfterStormJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const DisposeStrashAfterStormJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getdisposeStrashAfterStormEn(),
  }
  return FaqBagsterTemplate
}
